<template>
  <div class="container">
    <div class="container_bottom">
      <van-search
        v-model="searchVal"
        placeholder="请输入公告名称"
        show-action
        shape="round"
        @search="search"
        class="search"
      >
        <div class="search-btn" slot="action" @click="search">搜索</div>
      </van-search>
      <div class="container_img" @click="sidebar">
        <van-image width="6.3999984vw" height="5.8666652vw" :src="image" />
      </div>
    </div>
    <div class="container_antistop">
      <div
        class="search-btn"
        @click="keyWords"
        v-if="keyWord[0] == null || keyWord[0] == undefined"
      >
        添加关键字
      </div>
      <div
        :class="buttonIndex2 != 1 ? ' search-btns' : 'search-btns2'"
        @click="keyWordsd(keyWord[0].keyword, 1)"
        v-if="keyWord[0] != null && keyWord[0] != undefined"
      >
        {{ keyWord[0].keyword }}
      </div>

      <div class="search-btn" @click="keyWords" v-if="keyWord[1] == null || keyWord[1] == undefined">
        添加关键字
      </div>
      <div
        :class="buttonIndex2 != 2 ? ' search-btns' : 'search-btns2'"
        @click="keyWordsd(keyWord[1].keyword, 2)"
        v-if="keyWord[1] != null && keyWord[1] != undefined"
      >
        {{ keyWord[1].keyword }}
      </div>

      <div
        class="search-btn"
        @click="keyWords"
        v-if="keyWord[2] == null || keyWord[2] == undefined"
      >
        添加关键字
      </div>
      <div
        :class="buttonIndex2 != 3 ? ' search-btns' : 'search-btns2'"
        @click="keyWordsd(keyWord[2].keyword, 3)"
        v-if="keyWord[2] != null && keyWord[2] != undefined"
      >
        {{ keyWord[2].keyword }}
      </div>

      <div
        class="search-btn"
        @click="keyWords"
        v-if="keyWord[3] == null || keyWord[3] == undefined"
      >
        添加关键字
      </div>
      <div
        :class="buttonIndex2 != 4 ? ' search-btns' : 'search-btns2'"
        @click="keyWordsd(keyWord[3].keyword, 4)"
        v-if="keyWord[3] != null && keyWord[3] != undefined"
      >
        {{ keyWord[3].keyword }}
      </div>

      <div
        class="search-btn"
        @click="keyWords"
        v-if="keyWord[4] == null || keyWord[4] == undefined"
      >
        添加关键字
      </div>
      <div
        :class="buttonIndex2 != 5 ? ' search-btns' : 'search-btns2'"
        @click="keyWordsd(keyWord[4].keyword, 5)"
        v-if="keyWord[4] != null && keyWord[4] != undefined"
      >
        {{ keyWord[4].keyword }}
      </div>
    </div>
    <van-list
      class="listall"
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <van-cell
        class="listall-name"
        v-for="item in list"
        :key="item.id"
        @click="particulars(item)"
      >
        <!-- 公告类型 -->
        <div class="listtop" v-show="item.type == 1">
          <div class="listtop-iamge">
            <van-image :src="require('../../assets/img/type1.png')" />
          </div>
          <div class="listtop-content one">招标公告</div>
          <!-- <div class="listtop-tiem">{{ deteFormat(item.createTime) }}</div> -->
        </div>
        <div class="listtop" v-show="item.type == 5">
          <div class="listtop-iamge">
            <van-image :src="require('../../assets/img/type5.png')" />
          </div>
          <div class="listtop-content two">谈判采购公告</div>
          <!-- <div class="listtop-tiem">{{ deteFormat(item.createTime) }}</div> -->
        </div>
        <div class="listtop" v-show="item.type == 7">
          <div class="listtop-iamge">
            <van-image :src="require('../../assets/img/type7.png')" />
          </div>
          <div class="listtop-content three">竞价采购公告</div>
          <!-- <div class="listtop-tiem">{{ deteFormat(item.createTime) }}</div> -->
        </div>
        <div class="listtop" v-show="item.type == 2">
          <div class="listtop-iamge">
            <van-image :src="require('../../assets/img/type2.png')" />
          </div>
          <div class="listtop-content four">资格预审公告</div>
          <!-- <div class="listtop-tiem">{{ deteFormat(item.createTime) }}</div> -->
        </div>
        <div class="listtop" v-show="item.type == 3">
          <div class="listtop-iamge">
            <van-image :src="require('../../assets/img/type3.png')" />
          </div>
          <div class="listtop-content five">中标候选人公示</div>
          <!-- <div class="listtop-tiem">{{ deteFormat(item.createTime) }}</div> -->
        </div>
        <div class="listtop" v-show="item.type == 4">
          <div class="listtop-iamge">
            <van-image :src="require('../../assets/img/type4.png')" />
          </div>
          <div class="listtop-content six">中标结果公示</div>
          <!-- <div class="listtop-tiem">{{ deteFormat(item.createTime) }}</div> -->
        </div>
        <div class="listtop" v-show="item.type == 6">
          <div class="listtop-iamge">
            <van-image :src="require('../../assets/img/type6.png')" />
          </div>
          <div class="listtop-content seven">谈判采购拟成结果公告</div>
          <!-- <div class="listtop-tiem">{{ deteFormat(item.createTime) }}</div> -->
        </div>
        <div class="listtop" v-show="item.type == 8">
          <div class="listtop-iamge">
            <van-image :src="require('../../assets/img/type8.png')" />
          </div>
          <div class="listtop-content eight">竞价采购拟成结果公告</div>
          <!-- <div class="listtop-tiem">{{ deteFormat(item.createTime) }}</div> -->
        </div>
        <div class="listtop" v-show="item.type == 10">
          <div class="listtop-iamge">
            <van-image :src="require('../../assets/img/type10.png')" />
          </div>
          <div class="listtop-content nine">失信公告专栏</div>
          <!-- <div class="listtop-tiem">{{ deteFormat(item.createTime) }}</div> -->
        </div>
        <!-- //////////////////////////////////// -->

        <div class="list-list-contentd">
          <span v-html=" filterKeyWord(item.projectName)"></span>
          
        </div>
        <div class="list-list-content">
          公告属性<span
            >:&nbsp;{{ item.iscunepublic == 0 ? "公开" : "库内" }}</span
          >
        </div>
        <!-- <div class="list-list-content"><span>接受人:&nbsp;振勇</span></div> -->
        <div class="list-list-contents">
          <span>发布时间:&nbsp;{{ deteFormat(item.releaseTime) }}</span>
        </div>
      </van-cell>
    </van-list>
    <van-popup
      v-model="isshow"
      position="right"
      :style="{ height: '100%', width: '85%' }"
    >
      <div class="popup">
        <div class="popup_fabu">
          <div class="popup_fbsj">
            <van-image
              width="3.999999vw"
              height="3.999999vw"
              :src="require('../../assets/img/chaxu.png')"
            />
            <span>发布时间</span>
          </div>
          <div class="popup_kssj">
            <!-- <div class="popup_kssj1"  @click="startTime" v-if="filters.start == undefined">开始时间</div> -->
            <div class="popup_kssj1" @click="startTime">
              {{ filters.start == undefined ? "开始时间" : filters.start }}
            </div>
            <div class="popup_xg"></div>
            <div class="popup_jssj" @click="endTime">
              {{ filters.end == undefined ? "结束时间" : filters.end }}
            </div>
          </div>
        </div>
        <div class="popup_gonggao">
          <div class="popup_gglb">
            <van-image
              width="3.999999vw"
              height="3.999999vw"
              :src="require('../../assets/img/gglx.png')"
            />
            <span>公告类型</span>
          </div>
          <div class="popup_type">
            <div
              :class="buttonIndex == 1 ? ' qiehuan' : 'zbgg'"
              @click="type(1)"
            >
              <span>招标公告</span>
            </div>
            <div
              :class="buttonIndex == 5 ? 'qiehuan' : ' zbgg'"
              @click="type(5)"
            >
              <span>谈判采购公告</span>
            </div>
            <div
              :class="buttonIndex == 7 ? 'qiehuan' : ' zbgg'"
              @click="type(7)"
            >
              <span>竞价采购公告</span>
            </div>
          </div>
          <div class="popup_type">
            <div
              :class="buttonIndex == 2 ? 'qiehuan' : ' zbgg'"
              @click="type(2)"
            >
              <span>资格预审公告</span>
            </div>
            <div
              :class="buttonIndex == 3 ? 'qiehuan' : ' zbgg'"
              @click="type(3)"
            >
              <span>中标候选人公示</span>
            </div>
          </div>
          <div class="popup_type">
            <div
              :class="buttonIndex == 4 ? 'qiehuan' : ' zbgg'"
              @click="type(4)"
            >
              <span>中标结果公示</span>
            </div>
            <div
              :class="buttonIndex == 6 ? 'qiehuan' : ' zbgg'"
              @click="type(6)"
            >
              <span>谈判采购拟成公告</span>
            </div>
          </div>
          <div class="popup_type">
            <div
              :class="buttonIndex == 8 ? 'qiehuan' : ' zbgg'"
              @click="type(8)"
            >
              <span>失信公告专栏</span>
            </div>
            <div
              :class="buttonIndex == 10 ? 'qiehuan' : ' zbgg'"
              @click="type(10)"
            >
              <span>竞价采购拟成公告</span>
            </div>
          </div>
        </div>
        <div class="popup_button">
          <div class="popup-affirm" @click="SearchCancel">重置</div>
          <div class="popup-cancel" @click="SearchConfirm">确认</div>
        </div>
      </div>
    </van-popup>
    <!-- 开始时间 -->
    <van-popup
      v-model="isshowItem"
      position="bottom"
      :style="{ height: '40%' }"
    >
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        title="选择年月日"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="start"
        @cancel="startsole"
      />
    </van-popup>
    <!-- 结束时间 -->
    <van-popup v-model="isshowend" position="bottom" :style="{ height: '40%' }">
      <van-datetime-picker
        v-model="currentDate2"
        type="date"
        title="选择年月日"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="end"
        @cancel="endsole"
      />
    </van-popup>
    <!-- <div class="zhan"></div> -->
  </div>
</template>

<script>
import {
  Search,
  DropdownMenu,
  DropdownItem,
  Button,
  CellGroup,
  Cell,
  List,
  NavBar,
  Image,
  Dialog,
  Popup,
  DatetimePicker,
  Toast,
} from "vant";
import api from "@/api";
import Vue from "vue";
export default {
  components: {
    [Search.name]: Search,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Button.name]: Button,
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [List.name]: List,
    [NavBar.name]: NavBar,
    [Image.name]: Image,
    [Popup.name]: Popup,
    [Dialog.Component.name]: Dialog.Component,
    [DatetimePicker.name]: DatetimePicker,
    [Toast.name]: Toast,
  },
  data() {
    return {
      buttonIndex: 0, // 公告类型颜色
      buttonIndex2: 0, // 关键字颜色切换
      isshow: false,
      isshowItem: false,
      isshowend: false,
      searchVal: "",
      list: [],
      filters: {
        type: "",
      },
      pushStatus: "",
      finished: false,
      loading: false,
      page: "1",
      limit: "10",
      totalPage: 0,
      keyWord: [],
      image: require("@/assets/img/gunajianci.png"),
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(2025, 10, 1),
      currentDate: "",
      currentDate2: "",
      sartime: "开始时间",
    };
  },
  created() {
     this.getMyKeyword();
    
  },
  methods: {
    // 处理时间
    deteFormat(dateDate) {
      const date = dateDate.replace(/-/g, "-");
      const data = date.replace(/T/g, " ");
      return data;
    },
    deteFormats(dateDate) {
      const date = new Date(dateDate);
      const y = date.getFullYear();
      let m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let f = date.getMinutes();
      f = f < 10 ? "0" + f : f;
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      const time = y + "." + m + "." + d;
      return time;
    },
    // 公告类型切换
    type(val) {
      this.buttonIndex = val;

      this.filters.type = val;
      
    },
    // 开始时间
    startTime() {
      this.isshowItem = true;
    },
    // 开始时间 确认按钮
    start(value) {
      this.filters.start = this.deteFormats(value);

      this.isshowItem = false;
    },
    // 开始时间 取消按钮
    startsole() {
      this.isshowItem = false;
    },
    //结束时间
    endTime() {
      this.isshowend = true;
    },
    // 结束时间 确认按钮
    end(value) {
      this.filters.end = this.deteFormats(value);

      this.isshowend = false;
    },
    // 结束时间 取消按钮
    endsole() {
      this.isshowend = false;
    },

    // 关键字跳转
    keyWords() {
      this.$router.push({
        name: "myFocus",
        query: {
          pushStatus: this.pushStatus,
        },
      });
    },
    // 关键字搜索传值
    keyWordsd(value, index) {
      this.buttonIndex2 = index;
      this.filters.keyword = value;
      this.initializePage();
      
      this.getList();
    },
    // 初始化page
    initializePage() {
      this.list = [];
      this.page = "1";
    },
    // 关键字
    getMyKeyword() {
      api.workOrder.getMyKeyword().then((res) => {
        this.keyWord = res.data;

        this.pushStatus = res.pushStatus;
      });
    },
    //侧边栏
    sidebar() {
      this.isshow = true;
    },
    // 侧边栏 确认
    SearchConfirm() {
      if (this.filters.type != null) {
        this.initializePage();

        this.getList();
        this.isshow = false;
        return;
      }
      if (this.filters.end != null && this.filters.start != null) {
        this.initializePage();
        
        this.getList();
        
        
        this.isshow = false;
      } else {
        Toast("请输入开始时间和结束时间");
        return;
      }
    },
    // 侧边栏 取消
    SearchCancel() {
      this.buttonIndex = 0;
      this.buttonIndex2 = 0;
      this.filters.end = undefined;
      this.filters.start = undefined;
      this.filters.type = '';
      this.filters.keyword = '';
      this.isshow = true;
      // this.getList()
    },
    // 根据不同type获取列表
    getList() {
      this.findlist();
    },
    // 搜索点击
    search() {
      const params = {
        page: this.page,
        limit: this.limit,
        startDate: this.filters.start,
        endDate: this.filters.end,
        type: this.filters.type,
        text: this.searchVal,
        keyword: this.filters.keyword,
      };
      api.workOrder.getPushNotice(params).then((res) => {
        if (res.code === 0) {
          this.list = res.data;
          this.totalPage = res.totalPage;
          if (this.list.length <= 0) {
            setTimeout(() => {
              this.finished = true;
              this.loading = false;
            }, 10);
            
          } else {
            setTimeout(() => {
              this.loading = false;
            }, 10);
          }
        }
      });
    },
    // 高亮显示
    filterKeyWord(value) {
      
        const keyWord = this.keyWord
        
        if(keyWord.length == [] || keyWord == null || keyWord == undefined){
          console.log(keyWord,"keyWord")
          return value
        }else{
          console.log("//////22222222222")
          let text;  
       
        // 高亮要查找的字符串
        if (value) {
          
          // text = value.replace(keyWord[0].keyword === undefined || keyWord[0].keyword === null ? '' :  keyWord[0].keyword   , `<span style='background-color: yellow;'>${keyWord[0].keyword == undefined || keyWord[0].keyword == null ? '' :  keyWord[0].keyword }</span>`) ;
          if(keyWord[0] != undefined || keyWord[0] != null){
          text = value.replace(keyWord[0].keyword , `<span style='background-color: yellow;'>${keyWord[0].keyword }</span>`) ;

          }
          if(keyWord[1] != undefined || keyWord[1] != null){
          text = text.replace(keyWord[1].keyword , `<span style='background-color: yellow;'>${keyWord[1].keyword }</span>`) ;

          }
          if(keyWord[2] != undefined || keyWord[2] != null){
          text = text.replace(keyWord[2].keyword , `<span style='background-color: yellow;'>${keyWord[2].keyword }</span>`) ;

          }
          if(keyWord[3] != undefined || keyWord[3] != null){
          text = text.replace(keyWord[3].keyword , `<span style='background-color: yellow;'>${keyWord[3].keyword }</span>`) ;

          }
          if(keyWord[4] != undefined || keyWord[4] != null){
          text = text.replace(keyWord[4].keyword  , `<span style='background-color: yellow;'>${keyWord[4].keyword }</span>`) ;
          }
        } else {
          text = value;
        }
       
        return text;
        
        }
        
        
      
    },
    onLoad() {
      // onload事件进入页面就立即被调用了，所以一开始totalPage其实为0
      if (this.totalPage) {
        if (parseInt(this.page, 10) < this.totalPage) {
          this.page = parseInt(this.page, 10) + 1 + "";
          console.log(this.page, "55555555");
          this.getList();
        } else {
          setTimeout(() => {
            this.finished = true;
            this.loading = false;
          }, 10);
        }
      } else {
        this.getList();
      }
    },
    findlist() {
      const params = {
        page: this.page,
        limit: this.limit,
        startDate: this.filters.start,
        endDate: this.filters.end,
        type: this.filters.type,
        text: this.searchVal,
        keyword: this.filters.keyword,
      };

      api.workOrder.getPushNotice(params).then((res) => {
        if (res.code == 0) {
          this.list = [...this.list, ...res.data];
         
         
          this.totalPage = res.totalPage;
          setTimeout(() => {
            this.loading = false;
          }, 10);
        }
      });
    },
    // 区别公开库内
    particulars(item) {
      let orderInfo = {
        noticeNumber: item.noticeNumber,
        noticeType: item.type,
       
      };
      Vue.prototype.$orderInfo = orderInfo;
      if (this.type == 1 && item.iscunepublic == 1) {
        api.invitationFBid.getDetails().then((res) => {
          if (res.code == 0) {
            this.$router.push({
              name: "SubscribeDetails",
              
            });
          }
        });
      } else {
        this.$router.push({
          name: "SubscribeDetails",
          
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.qiehuan {
  min-width: 20.9333281vw;
  height: 6.2666651vw;
  line-height: 6.2666651vw;
  background: #4d94ff;
  color: #fff;
  margin-right: 4.7999988vw;
  margin-top: 3.1999992vw;
  text-align: center;
  border-radius: 3px;
  span {
    color: #fff;
    font-size: 3.1999992vw;
  }
}
::-webkit-scrollbar {
  width: 0px;
}
::-webkit-scrollbar {
  display: none; /*隐藏滚轮*/
}

.container {
  width: 100%;
  height: 100%;
  background: #f7f8fa;
  .container_bottom {
    width: 100%;
    // height: 100%;
    position: relative;
    background-color: #fff;

    .search {
      // padding: 2.66667vw 1.2vw;
      width: 92.5%;
    }
    .search-btn {
      position: absolute;
      right: 50px;
      top: 14px;
      background-color: #4d95fd;
      width: 55px;
      height: 28px;
      text-align: center;
      line-height: 28px;
      border-radius: 15px;
      color: white;
    }
    .container_img {
      position: absolute;
      bottom: 3.3vw;
      right: 3.8vw;
    }
  }
  .container_antistop {
    width: 100%;
    //计算长度值，定义的宽度是多少calc()中的数字就是多少
    // height: calc(100%); //动态计算长度值
    display: flex;
    background-color: #fff;

    overflow-x: auto;
    overflow-y: hidden;

    .search-btn {
      min-width: 10.3999954vw;
      max-width: 22vw;
      // width: 100%;
      // flex-shrink: 0;
      white-space: nowrap;
      position: relative;
      display: inline-block;
      margin-top: 5vw;
      margin-bottom: 2.5vw;
      background-color: #fff;
      width: 100%;
      height: 5.333332vw;
      margin-left: 2.5vw;
      font-size: 2.9333326vw;
      line-height: 5.333332vw;
      text-align: center;

      border: 1px solid #666666;
      border-radius: 6vw;
      color: #666666;
    }
    .search-btns {
      max-width: 30.3999954vw;

      // width: 100%;
      // flex-shrink: 0;
      white-space: nowrap;
      position: relative;
      display: inline-block;
      margin-top: 5vw;
      margin-bottom: 2.5vw;
      background-color: #fff;
      width: 100%;
      height: 5.333332vw;
      margin-left: 2.5vw;
      // margin-right: 2.5vw ;
      font-size: 3.1999992vw;
      line-height: 5.333332vw;
      text-align: center;

      // border: 1px solid #666666;
      // border-radius: 6vw;
      color: #333333;
    }
    .search-btns2 {
      min-width: 10.3999954vw;

      // width: 100%;
      // flex-shrink: 0;
      white-space: nowrap;
      position: relative;
      display: inline-block;
      margin-top: 5vw;
      margin-bottom: 2.5vw;
      background-color: #fff;
      width: 100%;
      height: 5.333332vw;
      margin-left: 2.5vw;
      font-size: 3.1999992vw;
      line-height: 5.333332vw;
      text-align: center;

      // border: 1px solid #666666;
      // border-radius: 6vw;
      color: #4d94ff;
    }
    //     .search-btns2::before {
    //     content: '';
    //     position: absolute;
    //     left: 22%;
    //     right: 0;
    //     bottom: -3px;
    //     // text-align: center;
    //     width: 40%;
    //     height: 1vw;
    //     margin: auto;
    //     border-radius: 6rpx;
    //     border-bottom: 3px solid #4D94FF;
    //     box-sizing: border-box;
    // }
  }
  .listall {
    margin-top: 0.6rem;
    margin-right: 0.6rem;
    margin-left: 0.6rem;
    height: 80%;
    overflow: auto;
  }
  .listall-name {
    border-radius: 0.6rem;
    margin-bottom: 1rem;
    // height: 10rem;
    .listtop {
      display: flex;
      // justify-content: space-between;
      height: 2.6rem;
      align-items: center;
      border-bottom: 1px solid #eee;

      .listtop-iamge {
        .van-image {
          width: 3.999999vw;
          height: 3.999999vw;
          vertical-align: middle;
        }
      }
      .one {
        color: #5db974;
      }
      .two {
        color: #4d94ff;
      }
      .three {
        color: #faa105;
      }
      .four {
        color: #fa5405;
      }
      .five {
        color: #08b4b6;
      }
      .six {
        color: #63ff4b;
      }
      .seven {
        color: #ff4f99;
      }
      .eight {
        color: #4f66ff;
      }
      .nine {
        color: #ff4d4d;
      }
      .listtop-content {
        flex: 3;
        padding-top: 1vw;
        margin-left: 0.3rem;
        height: 4.9333321vw;
        line-height: 4.9333321vw;
        font-size: 3.7333324vw;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .listtop-tiem {
        padding-left: 3rem;
        // flex: 2;
        color: #999999;
        font-size: 2.666666;
      }
    }
    .list-list-contentd {
      margin-top: 0.3rem;
      color: #333333;
      font-size: 3.7333324vw;
    }
    .list-list-content {
      margin-top: 0.3rem;
      color: #999999;
      font-size: 3.066666vw;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .list-list-contents {
      margin-top: -0.3rem;
      color: #999999;
      font-size: 3.066666vw;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .popup {
    width: 100%;
    height: 100%;
    padding-left: 5.0666654vw;
    .popup_fabu {
      width: 100%;
      // margin-left: 5.0666654vw;

      .popup_fbsj {
        margin-top: 5.7333319vw;
        .van-image {
          vertical-align: middle;
        }
        span {
          margin-left: 1vw;
          font-size: 3.999999vw;
          color: #333333;
        }
      }
      .popup_kssj {
        width: 100%;
        margin-top: 4.5333322vw;
        display: flex;
        .popup_kssj1 {
          width: 28.2666596vw;
          height: 6.2666651vw;
          line-height: 6.2666651vw;
          border: 1px solid #999;
          border-radius: 3px;
          padding-left: 1vw;
          color: #999999;
          font-size: 3.1999992vw;
        }
        .popup_xg {
          height: 2px;
          width: 5vw;
          // border: 1px solid rgb(185, 182, 182);
          background-color: rgb(185, 182, 182);
          margin-top: 2.5vw;
          margin-left: 2vw;
          margin-right: 2vw;
        }
        .popup_jssj {
          width: 28.2666596vw;
          height: 6.2666651vw;
          line-height: 6.2666651vw;
          border: 1px solid #999;
          border-radius: 3px;
          font-size: 3.1999992vw;
          padding-left: 1vw;
          color: #999999;
        }
      }
    }
    .popup_gonggao {
      width: 100%;
      .popup_gglb {
        margin-top: 6.7999983vw;
        .van-image {
          vertical-align: middle;
        }
        span {
          margin-left: 1vw;
          font-size: 3.999999vw;
          color: #333333;
        }
      }
      .popup_type {
        width: 100%;
        display: flex;
        .zbgg {
          min-width: 20.9333281vw;
          height: 6.2666651vw;
          line-height: 6.2666651vw;
          background: #f0f0f0;
          margin-right: 4.7999988vw;
          margin-top: 3.1999992vw;
          text-align: center;
          border-radius: 3px;
          span {
            color: #333333;
            font-size: 3.1999992vw;
          }
        }
      }
    }
    .popup_button {
      display: flex;
      width: 100%;
      margin-left: -5.0666654vw;
      position: absolute;
      bottom: 0vw;
      text-align: center;
      .popup-affirm {
        width: 50%;
        height: 13.0666634vw;
        color: #666;
        font-size: 3.999999vw;
        line-height: 13.0666634vw;
        border-top: 1px solid #999;
        border-bottom: 1px solid #999;
        // flex:1;
        //     background-color: coral;
        //     height: 50px;
        //     justify-content: flex-end;
        //     display: flex;
        //     align-items: center;
      }
      .popup-cancel {
        width: 50%;
        height: 13.0666634vw;
        color: #1888f4;
        font-size: 3.999999vw;
        line-height: 13.0666634vw;
        border-top: 1px solid #999;
        border-bottom: 1px solid #999;
        border-left: 1px solid #999;
      }
    }
  }
  .zhan {
    height: 22vw;
    background: #f8f8f8;
  }
}
</style>
